import moment from "moment"

export const formatElectionDate = electionDate => {
  const date = moment(electionDate, "YYYY-MM-DD", true)
  return date.isValid() ? date.format("MMMM D, YYYY") : null
}
